"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Auth = void 0;
/* https://confluence.shopee.io/display/IPG/1.2.1+MDAP+-+Application+Authorization+Protocol+V1 */
var constants_1 = require("../constants");
var sha256_1 = __importDefault(require("jssha/dist/sha256"));
var request_1 = require("./request");
var storage_1 = require("../utils/storage");
var isSuccessRes = function isSuccessRes(result) {
  var _a;
  return (_a = result) === null || _a === void 0 ? void 0 : _a.access_token;
};
var MAX_RETYR_LIMIT = 2;
// disable retrying if failed to login in one minute
var AUTH_RETRY_INTERVAL = 60 * 1000;
// 用一个不太明显是token的
var TOKEN_STORAGE_KEY = 'persisttk';
// default - cache auth for 20 mins
var AUTH_DEFAULT_MAX_AGE = 20 * 60000;
/** get expire timestamp from server - default max age: 30mins */
var isUnexpired = function isUnexpired(expireAt) {
  return !!(expireAt && +new Date() < expireAt - 60000);
};
var Auth = /** @class */function () {
  function Auth(configs) {
    this.pending = false;
    this.pendingTasks = [];
    this.loginFailed = false;
    /**
     * last login time. For preventing login retry within a short time (server error or other reason)
     */
    this.lastLogin = 0;
    this.app_name = configs.app_name;
    this.secret_key = configs.secret_key;
    this.host = configs.host;
    this.storage = new storage_1.MdapStorage({
      name: "mdap_persisttk_" + this.app_name + "_" + configs.env
    });
  }
  Auth.prototype.onFulfilled = function () {
    var _a;
    while (this.pendingTasks.length) {
      var executor = ((_a = this.pendingTasks.shift()) !== null && _a !== void 0 ? _a : {}).executor;
      executor === null || executor === void 0 ? void 0 : executor(true);
    }
  };
  Auth.prototype.onRejected = function () {
    var _a;
    while (this.pendingTasks.length) {
      var reject = ((_a = this.pendingTasks.shift()) !== null && _a !== void 0 ? _a : {}).reject;
      reject === null || reject === void 0 ? void 0 : reject(false);
    }
  };
  Auth.prototype.getCachedToken = function () {
    var result = this.storage.getObject(TOKEN_STORAGE_KEY);
    /**
     * 走入获取缓存的逻辑，当token有值且缓存的值与当前的值相等，说明缓存的token已失效
     * 获取到不同的token，说明token已被其他线程更新
     */
    if (this.token && (result === null || result === void 0 ? void 0 : result.token) === this.token) {
      return undefined;
    }
    if ((result === null || result === void 0 ? void 0 : result.maxAge) && result.lastUpdate && isUnexpired(result.lastUpdate + result.maxAge)) {
      // unexpired - use token from cache
      this.tokenExpireAt = result.lastUpdate + result.maxAge;
      return result.token;
    }
    return undefined;
  };
  Auth.prototype.cacheToken = function (response) {
    var current = +new Date();
    this.storage.setObject(TOKEN_STORAGE_KEY, {
      lastUpdate: current,
      token: response.access_token,
      maxAge: response.max_age ? response.max_age * 1000 : AUTH_DEFAULT_MAX_AGE
    });
  };
  /** https://confluence.shopee.io/pages/viewpage.action?pageId=465805384 */
  Auth.prototype.fetchToken = function () {
    return __awaiter(this, void 0, void 0, function () {
      var cacheToken, timeStamp, shaObj, sign, res, maxAge, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (this.pending) {
              return [2 /*return*/];
            }

            cacheToken = this.getCachedToken();
            if (cacheToken) {
              this.token = cacheToken;
              this.onFulfilled();
              this.loginFailed = false;
              return [2 /*return*/, {
                access_token: cacheToken
              }];
            }
            this.pending = true;
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            timeStamp = +new Date();
            shaObj = new sha256_1.default('SHA-256', 'TEXT');
            shaObj.update("" + this.app_name + this.secret_key + timeStamp);
            sign = shaObj.getHash('HEX');
            return [4 /*yield*/, request_1.APIs.postXHR({
              url: "" + this.host + constants_1.apiMaps.login,
              data: {
                app_name: this.app_name,
                sign: sign,
                timestamp: timeStamp
              }
            })];
          case 2:
            res = _a.sent();
            if (isSuccessRes(res)) {
              this.token = res.access_token;
              this.onFulfilled();
              this.pending = false;
              this.loginFailed = false;
              this.lastLogin = +new Date();
              maxAge = res.max_age ? res.max_age * 1000 : AUTH_DEFAULT_MAX_AGE;
              this.tokenExpireAt = maxAge + +new Date();
              this.cacheToken(res);
              return [2 /*return*/, res];
            }
            return [3 /*break*/, 4];
          case 3:
            error_1 = _a.sent();
            return [3 /*break*/, 4];
          case 4:
            this.onRejected();
            this.pending = false;
            this.loginFailed = true;
            this.lastLogin = +new Date();
            return [2 /*return*/, false];
        }
      });
    });
  };
  Auth.prototype.checkAuth = function () {
    return __awaiter(this, void 0, void 0, function () {
      var isTokenUnExpired, shouldRetryAuth;
      var _this = this;
      return __generator(this, function (_a) {
        isTokenUnExpired = isUnexpired(this.tokenExpireAt);
        if (!this.pending && !this.loginFailed && isTokenUnExpired) {
          return [2 /*return*/, true];
        }
        shouldRetryAuth = +new Date() - this.lastLogin > AUTH_RETRY_INTERVAL;
        if (this.loginFailed && !shouldRetryAuth) {
          return [2 /*return*/, Promise.reject(new Error('login failed'))];
        }
        if (shouldRetryAuth || !isTokenUnExpired) {
          return [2 /*return*/, this.updateAuth()];
        }
        // pending updating token
        return [2 /*return*/, new Promise(function (resolve, reject) {
          _this.pendingTasks.push({
            executor: resolve,
            reject: reject
          });
        })];
      });
    });
  };
  Auth.prototype.updateAuth = function () {
    return __awaiter(this, void 0, void 0, function () {
      var currentToken;
      var _this = this;
      return __generator(this, function (_a) {
        currentToken = this.token;
        if (!this.pending) {
          this.fetchToken();
        }
        /** if get valid token from cache, token has been updated already in synchronizing task */
        if (this.token && currentToken !== this.token) {
          return [2 /*return*/, true];
        }
        return [2 /*return*/, new Promise(function (resolve, reject) {
          _this.pendingTasks.push({
            executor: resolve,
            reject: reject
          });
        })];
      });
    });
  };
  /** 请求因鉴权失败时, 更新token, 并在token更新后进行重试 */
  Auth.prototype.authRetryWrapper = function (func) {
    return __awaiter(this, void 0, void 0, function () {
      var retryCount, _tryOnce;
      var _this = this;
      return __generator(this, function (_a) {
        retryCount = 0;
        _tryOnce = function tryOnce() {
          return __awaiter(_this, void 0, void 0, function () {
            var res, error_2;
            var _a;
            return __generator(this, function (_b) {
              switch (_b.label) {
                case 0:
                  _b.trys.push([0, 2,, 3]);
                  return [4 /*yield*/, func()];
                case 1:
                  res = _b.sent();
                  if (![constants_1.API_ERROR_CODE.UNAUTHORIZED_TOKEN, constants_1.API_ERROR_CODE.TOKEN_EXPIRED].includes((_a = res) === null || _a === void 0 ? void 0 : _a.code)) {
                    // 非鉴权失败的场景，直接返回
                    return [2 /*return*/, res];
                  }
                  return [3 /*break*/, 3];
                case 2:
                  error_2 = _b.sent();
                  // console.trace(error);
                  return [2 /*return*/, error_2];
                case 3:
                  if (retryCount >= MAX_RETYR_LIMIT) {
                    this.loginFailed = true;
                    return [2 /*return*/];
                  }

                  retryCount += 1;
                  return [4 /*yield*/, this.updateAuth()];
                case 4:
                  _b.sent();
                  return [2 /*return*/, _tryOnce()];
              }
            });
          });
        };
        return [2 /*return*/, _tryOnce()];
      });
    });
  };
  return Auth;
}();
exports.Auth = Auth;